<template>
	<div class="full">
		<vxe-grid v-bind="gridOptions" v-if="gridOptions" :loading="loading" ref="wlnpurchaseDetail" @toolbar-button-click="toolbarButtonClickEvent"></vxe-grid>
		<reportgoods-form :componentStore="componentStore" ref="reportgoodsForm" :row="currentRow" :detail="detail" />
		<bargain-form :componentStore="componentStore" ref="bargainForm" :row="currentRow" :detail="detail" />
		<modifieddetail-form :componentStore="componentStore" :row="currentRow" ref="modifieddetailForm"  />
	</div>
</template>
<style scoped>

</style>
<script>
	import reportgoodsForm from './form/reportgoods'
	import bargainForm from './form/bargain'
	import modifieddetailForm from './form/modifieddetail'
	export default {
		props: {
			componentStore: {
				default: () => {
					return null
				}
			},
			item: {
				type: Object,
				default: () => {
					return {}
				}
			},
			ordertypeMap: {
				type: Object,
				default: () => {
					return {}
				}
			},
			currentRow: {
				default: () => {
					return null
				}
			},
			toolbarButtonConfig: {
				default: () => {
					return []
				}
			},
			toolbarButtonList: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				loading: false,
				gridOptions: null,
				toolbarButton:[],
				detail:[]
			}
		},
		watch: {
			currentRow(e) {
				if (e) {
					this.$api.wlnpurchase.getDetail({ids:e.billID}).then((res) => {
						this.$refs.wlnpurchaseDetail.reloadData(res)
					})
				} else {
					this.$refs.wlnpurchaseDetail.reloadData([])
				}
			},
			toolbarButtonConfig(){
				this.getToolbarButton()
			}
		},
		computed: {

		},
		created() {

		},
		mounted() {
			

		},
		methods: {
			getOption() {
				return {
					id: 'wlnpurchaseDetail',
					border: true,
					size: 'mini',
					columns: this.getColumns(),
					columnConfig: {
						isHover: false,
						resizable: true
					},
					customConfig: {
						storage: true
					},
					cellStyle:this.cellStyle,
					toolbarConfig: {
						size: 'mini',
						perfect: false,
						zoom:true,
						buttons: this.toolbarButton,
						customConfig: {
							storage: true
						},
					},
					rowConfig: {
						isHover: true,
						isCurrent: true,
					},
					showHeaderOverflow:true,
					showOverflow: true,
					height: 'auto',
					pagerConfig: {
						enabled: false
					},
					proxyConfig: {},
					sortConfig: {
						remote: false
					}
				}
			},
			getColumns() {
				return [{
					title: '#',
					type: 'seq',
					width: 30
				},{
					type: 'checkbox',
					width: 60
				}, {
					field: 'skuCode',
					title: '商品编码',
					width: 120
				}, {
					field: 'status',
					title: '状态',
					formatter:this.wlnpurchasestatusFormatter
				}, {
					field: 'isoutofstock',
					title: '是否缺货',
					formatter:({row})=>{
						return row.isoutofstock==1?'是':'否'
					}
				}, {
					field: 'outofstockmark',
					title: '缺货原因'
				}, {
					field: 'goodsName',
					title: '商品名称'
				}, {
					field: 'skuName',
					title: '规格名称'
				}, {
					field: 'unitName',
					title: '单位',
					width:50
				}, {
					field: 'price',
					title: '单价',
					width:50
				}, {
					field: 'nazhi_pricefluctuations',
					title: '波动(%)',
					width:50
				}, {
					field: 'size',
					title: '数量',
					width:50
				}, {
					field: 'receive',
					title: '入库',
					width:50
				}, {
					field: 'sum',
					title: '总价',
					width:50
				}, 
				// {
				// 	field: 'articleNumber',
				// 	title: '货号'
				// }, 
				{
					field: 'planArriveDate',
					title: '预计到货日期',
					formatter:({row})=>{
						return window.systemMethods.timestampToDate(row.planArriveDate,true)
					}
				}, {
					field: 'remark',
					title: '备注'
				}, {
					field: 'reportNum',
					title: '报次',
					fixed:'right',
					width:50
				}, {
					field: 'bargainNum',
					title: '砍次',
					fixed:'right',
					width:50
				}, {
					field: 'takeStatus',
					title: '提货',
					formatter:this.takeStatus,
					fixed:'right'
				}, {
					field: 'taketime',
					title: '提货时间',
					formatter:({row})=>{
						return window.systemMethods.timestampToDate(row.taketime,true)
					},
					fixed:'right'
				}, {
					field: 'reportAgeing',
					title: '报货时效(小时)',
					showHeaderOverflow:true,
					fixed:'right'
				}, {
					field: 'takeAgeing',
					title: '提货时效(小时)',
					showHeaderOverflow:true,
					fixed:'right'
				}]
			},
			getToolbarButton() {
				let buttons  = []
				let toolbarButtonList = this.toolbarButtonList.filter((item)=>{
					return item.custom
				})
				this.toolbarButtonConfig.forEach((item)=>{
					let obj = toolbarButtonList.find((_item)=>{
						return _item.code == item
					})
					if(obj){
						buttons.push(obj)
					}
				})
				this.toolbarButton = buttons
				
				this.gridOptions = this.getOption()
			},
			
			toolbarButtonClickEvent(e){
				if(this[e.code]){
					this[e.code]()
				}
			},
			reportgoods(){
				let data = this.$refs.wlnpurchaseDetail.getCheckboxRecords()
				if(data.length==0){
					this.$message.error('请选择商品')
					return
				}
				this.detail = data
				this.$nextTick(()=>{
					this.$refs.reportgoodsForm.modalShow()
				})
			},
			bargain(){
				let data = this.$refs.wlnpurchaseDetail.getCheckboxRecords()
				if(data.length==0){
					this.$message.error('请选择商品')
					return
				}
				this.detail = data
				this.$nextTick(()=>{
					this.$refs.bargainForm.modalShow()
				})
			},
			takegoods(){
				let data = this.$refs.wlnpurchaseDetail.getCheckboxRecords()
				if(data.length==0){
					this.$message.error('请选择商品')
					return
				}
				this.detail = data
				this.$confirm('是否确认提货','提示').then(()=>{
					this.$api.wlnpurchase.takegoods({
						data: this.detail
					}).then(() => {
						this.$message.success('操作成功')
					})
				})
			},
			modifieddetail(){
				let data = this.$refs.wlnpurchaseDetail.getTableData().fullData
				if(data.length==0){
					this.$message.error('暂无明细数据')
					return
				}
				this.$refs.modifieddetailForm.data = this.$refs.wlnpurchaseDetail.getTableData().fullData
				this.$refs.modifieddetailForm.modal_show()
			},
			takeStatus({
				cellValue
			}){
				if(cellValue==0){
					return '未提货'
				}else{
					return '已提货'
				}
			},
			wlnpurchasestatusFormatter({
				cellValue
			}) {
				let purchasegoodsMap = {
					'0': 8107,
					'1': 8110,
					'2': 8109,
					'3': 8111,
					'99': 8964
				}
				return window.systemMethods.getEmunValue('wlnpurchasestatus', purchasegoodsMap[cellValue])
			},
			cellStyle({
				row,
				column
			}) {
				if (row.grabstatus == 8113) {
					return {
						backgroundColor: 'rgb(233, 233, 235)'
					}
				}
				if (column.field == 'status') {
					if (row.status == 0) {
						return {
							color: '#F56C6C'
						}
					}
					if (row.status == 1) {
						return {
							color: '#409EFF'
						}
					}
					if (row.status == 2) {
						return {
							color: '#67C23A'
						}
					}
				}
				if (column.field == 'takeStatus') {
					if (row.takeStatus == 0) {
						return {
							color: '#F56C6C'
						}
					}else  {
						return {
							color: '#67C23A'
						}
					}
				}
			},
		},
		components: {
			reportgoodsForm,
			bargainForm,
			modifieddetailForm
		}
	}
</script>